import React, { useState } from 'react'
import { Box, Button, Grid, IconButton, InputLabel, Typography, useTheme } from '@mui/material'
import { formatCurrency } from '../DealsKanban/aggregateStageTotals'
import RenderServiceIcon from '../RenderServiceIcons/RenderServiceIcon'
import CampaignIcon from '@mui/icons-material/Campaign'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import SaveIconButton from 'components/ui/save-icon-button'

interface RenderProductProps {
  strategy?: any
  organization?: any
  service: any
  isEditing: any
  onEditClick: any
  onCancelClick: any
  onSaveClick: any
  hasErrors: any
}

const RenderProduct = ({ service, isEditing, onEditClick, onCancelClick, onSaveClick, hasErrors }: RenderProductProps) => {
  const { dealId } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const theme = useTheme()
  const [isHovered, setIsHovered] = useState(false)
  const [campaignId, setCampaignId] = useState(service.instanceId || '')
  const handleNavigate = () => {
    navigate(`${pathname}/${service.instanceId}`)
  }

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        p: 1,
        border: '1px solid',
        borderColor: theme.palette.text.secondary,
        bgcolor: theme.palette.background.sectionContent,
        zIndex: 17, // Adjust stacking order
        width: '100%',
        position: 'relative',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Grid
        item
        xs={3}
        sx={{ display: 'flex', flexDirection: 'column' }}
        // onMouseEnter={() => setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
        gap={0.5}
      >
        <Box sx={{ position: 'relative' }}>
          {/* <InputLabel
            sx={{
              fontSize: 12,
              opacity: isHovered ? 1 : 0,
              textAlign: 'left',
              transition: 'opacity 0.5s ease-in-out',
            }}
          >
            {isHovered ? `${service.instanceId}` : ''}
          </InputLabel> */}
          <InputLabel
            sx={{
              fontSize: 12,
              // opacity: !isHovered ? 1 : 0,
              textAlign: 'left',
              transition: 'opacity 0.5s ease-in-out',
            }}
          >
            {/* {!isHovered ? 'Service' : ''} */}
            {'Service'}
          </InputLabel>
        </Box>
        <RenderServiceIcon service={service.productName} />
      </Grid>
      <Grid item xs={2} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <InputLabel sx={{ fontSize: 12 }}>Payer</InputLabel>
        <Typography>{service.payer || '—'}</Typography>
      </Grid>
      <Grid item xs={2} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <InputLabel sx={{ fontSize: 12 }}>Account Used</InputLabel>
        <Typography>{service.accountUsed || '—'}</Typography>
      </Grid>
      <Grid item xs={1.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <InputLabel sx={{ fontSize: 12 }}>Media Spend</InputLabel>
        <Typography>{formatCurrency(service.mediaSpend)}</Typography>
      </Grid>
      <Grid item xs={1.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <InputLabel
          sx={{
            fontSize: 12,
          }}
        >
          Price
        </InputLabel>
        <Typography
          sx={{ color: service.payer === 'Client' ? theme.palette.text.warning : theme.palette.text.primary }}
        >
          {formatCurrency(service.price)}
        </Typography>
      </Grid>

      <Grid item xs={1} sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <InputLabel
          sx={{
            fontSize: 12,
          }}
        >
          Campaign
        </InputLabel>
        <IconButton
          onClick={handleNavigate}
          style={{
            display: 'flex',
            textDecoration: 'none',
            color: 'inherit',
            backgroundColor: 'transparent',
            height: 30,
            width: 30,
          }}
        >
          <CampaignIcon sx={{ height: 30, width: 30 }} />
        </IconButton>
      </Grid>
      <Grid item xs={1}>
        {(isHovered || isEditing) && (
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 20,
              display: 'flex',
              gap: 1,
              backgroundColor: 'transparent',
              backdropFilter: 'blur(10px)',
            }}
          >
            {isEditing ? (
              <>
                {/* <SaveIconButton hasErrors={hasErrors} onSave={() => onSaveClick(service.instanceId)} /> */}
                <SaveIconButton hasErrors={false} onSave={() => onSaveClick(service.instanceId)} />
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={() => onCancelClick(service.instanceId)}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                variant="outlined"
                size="medium"
                onClick={() => onEditClick(service.instanceId)}
                sx={{ color: 'text.warning' }}
              >
                Edit
              </Button>
            )}
          </Box>
        )}
      </Grid>

      {/* <Link
            // to={`/deals/${dealId}/strategy/${campaignId}`}
            to={`${pathname}/${campaignId}`}
            style={{
              display: 'flex',
              textDecoration: 'none',
              color: 'inherit',
              backgroundColor: 'transparent',
            }}
          >
            <CampaignIcon sx={{ height: 30, width: 30 }} />
          </Link> */}
    </Grid>
  )
}

export default RenderProduct
